import { getAppNameFromPath } from '../../Utilities/PathUtilities';
import Browser from '../../Utilities/Browser';

const configuration = {
    isProductionBuild: import.meta.env.PROD,
    buildVersion: ECARGO_APP_VERSION,
    basePath: '/App',
    legacyBasePath: '/Online',
    tooltipShowDelay: 500, //Milliseconds before showing tooltip on hover
    uiDateFormat: 'DD/MM/YYYY',
    uiDisplayDateFormat: 'DD MMM YYYY',
    uiTimeInputFormat: 'HH:mm',
    acceptableInputDateFormats: [ 'D/M/YYYY', 'D/M/YY', 'D/M', 'DD/MM/YYYY' ],
    iso8601DateOnlyFormat: 'YYYY-MM-DD',
    pageTitlePrefix : 'eCargo',
    pageTitleSeparator: ' | ',
    defaultProfile: {
        user: { fullName: 'My account' },
        business: { fullName: 'eCargo' }
    },
    headerHeightPixels: 43
};

const appPath = Browser.window && Browser.window.location ? Browser.window.location.pathname : ''

configuration.appName = getAppNameFromPath(configuration.basePath, appPath);
export default configuration;
